import httpApiApplication from '../../http/httpApiApplication';

import { type PenaltyRequest } from './types';

export const BaseUrlPenalties = '/penalties';

export const createPenalty = async (request: PenaltyRequest) => {
  return await httpApiApplication.post(BaseUrlPenalties, request);
};

export const deletePenalty = async (id: string) => {
  return await httpApiApplication.delete(`${BaseUrlPenalties}/${id}`);
};

export const editPenalty = async (id: string, request: PenaltyRequest) => {
  return await httpApiApplication.put(`${BaseUrlPenalties}/${id}`, request);
};
